import React, { Component, Fragment } from "react";
import { matchPath } from "react-router";
import api from "services/api";
import moment from "moment";

import { connect } from "react-redux";

import { withTranslation } from "react-i18next";
import { compose } from "recompose";

import { Page } from "components";

class Complete extends Component {
  state = {
    interview: {},
    loading: true
  };

  componentDidMount() {
    this.loadInterview();
  }

  loadInterview = async () => {
    const response = await api.get(`search/interviews/${this.handleGetID()}`);
    const { data } = response.data;

    this.setState({
      interview: {
        ...data,
        attributes: {
          ...data.attributes,
          downloadable:
            data.attributes.calculated &&
            moment(data.attributes.calculated_at).isBefore(moment())
        }
      },
      loading: false
    });
  };

  handleGetID = () => {
    const { location } = this.props;
    const match = matchPath(location.pathname, {
      path: "/journey/:id/complete"
    });
    return match.params.id;
  };

  render() {
    const { interview, loading } = this.state;
    const { t } = this.props;

    return (
      <Page className="journey">
        <div className="complete">
          <h2>{t("Parabéns")}</h2>
          <p>{t("Você concluiu com sucesso o questionário!")}</p>

          {!loading && (
            <Fragment>
              {interview.attributes.downloadable ? (
                <a
                  href={`${process.env.REACT_APP_API_URL}reports/pdf/generate/${interview.id}`}
                  className="button-submit"
                >
                  {t("Fazer Download do Relatório")}
                </a>
              ) : (
                <p>
                  {t(
                    "Quando disponível, você receberá um e-mail com o link para baixar seu relatório."
                  )}
                </p>
              )}
            </Fragment>
          )}
        </div>
      </Page>
    );
  }
}

const mapState = state => ({
  user: state.auth.user
});

export default compose(connect(mapState), withTranslation())(Complete);



// WEBPACK FOOTER //
// ./src/pages/Journey/Complete/index.js